import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, PopoverController, Content, Platform, Events } from 'ionic-angular';
import moment from 'moment';
import { EventsProvider } from '../../providers/events/events';
import { CoEventsDayComponent } from '../../components/co-events-day/co-events-day';
import { CoEventsWeekComponent } from '../../components/co-events-week/co-events-week';
import { CoPopoverEventsFilterComponent } from '../../components/co-popover-events-filter/co-popover-events-filter';
import { CoExploreEventsBlockComponent } from '../../components/co-explore-events-block/co-explore-events-block';
import { CoEventsMonthComponent } from '../../components/co-events-month/co-events-month';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { CoEventsRangeComponent } from '../../components/co-events-range/co-events-range';
import { AppState } from '../../config/state';
import { CoEventsMonthDropdownComponent } from '../../components/co-events-month-dropdown/co-events-month-dropdown';
import { CoWeekCalendarViewComponent } from '../../components/co-week-calendar-view/co-week-calendar-view';
import { CoEventsBrochureModalPage } from '../co-events-brochure-modal/co-events-brochure-modal';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoEventsExploreDesktopComponent } from '../../components/co-events-explore-desktop/co-events-explore-desktop';
/**
 * Generated class for the AttendPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-attend',
  templateUrl: 'attend.html'
})
export class AttendPage {
  @ViewChild(CoExploreEventsBlockComponent) exploreEvents: CoExploreEventsBlockComponent;
  @ViewChild(CoEventsExploreDesktopComponent) desktopEvents: CoEventsExploreDesktopComponent;
  @ViewChild(CoEventsDayComponent) dayEvents: CoEventsDayComponent;
  @ViewChild(CoEventsWeekComponent) weekEvents: CoEventsWeekComponent;
  @ViewChild(CoWeekCalendarViewComponent) weekCalendarEvents: CoEventsWeekComponent;
  @ViewChild(CoEventsMonthComponent) monthEvents: CoEventsMonthComponent;
  @ViewChild(CoEventsMonthDropdownComponent) monthDropdownEvents: CoEventsMonthDropdownComponent;
  @ViewChild(CoEventsRangeComponent) rangeEvents: CoEventsRangeComponent;
  @ViewChild(Content) content: Content;
  eventsQueryArgs: string = `startDate: "${moment().subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}"`;
  eventsView: string = "explore";
  allEventsQuery: any;
  popOverFilter: any = {};
  currentDay: any;
  isFilterActive: any = {};
  clientKeyword: any;
  viewType: string;
  searchInput: string;
  timeRangeForBrochurePrint: string;
  timeRangeDesktop: any = { lower: 0, upper: 24 };
  timeRangeDesktopButtons: string;
  densityForFilters: number = 1;
  clock: boolean;
  wideScreen: boolean;
  pageTitle: string = "Attend";
  displayTime: any = { lower: moment().hour(this.timeRangeDesktop.lower).startOf('hour'), upper: moment().hour(this.timeRangeDesktop.upper).startOf('hour') }
  // burgerMenu: any;
  // menuSide: string;
  filterParameters: any = {
    tracker: false
  };
  menuSide: string;
  showAllBranchEvents: boolean;
  constructor(public navCtrl: NavController, public navParams: NavParams, public eventsProvider: EventsProvider, public popoverCtrl: PopoverController, public clientDetails: ClientDetailsProvider, public state: AppState, public modalCtrl: ModalController, private platform: Platform, private events: Events, private sounds : SoundsProvider) {
    this.events.subscribe('sendMoreEventsFromExplore', (res) => {
      this.eventsView = 'day';
      this.popOverFilter = res;
      this.filterParameters = res;
      // this.queryForDateRange(res.date);
    })
    this.events.subscribe('setAttendFilters', res=>{
      this.filterEvents(res);
    })
    this.wideScreen = this.platform.width() > 600;
    this.showAllBranchEvents = !this.wideScreen;
    this.currentDay = moment().format("YYYY-MM-DD HH:mm:ss");
    this.clock = this.state.clockEnabledOnScreen;
    let self = this;
    clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
    });
    // this.burgerMenu = this.state.burgerMenu;
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";

    if (this.navParams.data&&this.navParams.data.hasOwnProperty('blockInfo')){
      this.pageTitle = this.navParams.get('blockInfo').title;
    }
  }

  changeView(eventsView) {
    this.sounds.ButtonClick();
    this.densityForFilters = 0;
    this.content.scrollToTop();

    if (eventsView === 'explore'){
      setTimeout(()=>this.toggleAllBranch(),0);
    }
  }
  ngOnDestroy(){
    this.events.unsubscribe('sendMoreEventsFromExplore');
    this.events.unsubscribe('setAttendFilters');
  }
  ngOnInit() {
    // if (this.navParams.data.filter) {
    //   let filter = this.navParams.data.filter;
    //   this.eventsView = this.navParams.data.eventView;
    //   this.popOverFilter = filter;
    //   this.filterParameters['location'] = filter.location;
    //   this.isFilterActive['location'] = true;
    // };
    if (this.navParams.data.filter) {
      // console.log(this.navParams, this.navParams.data.filter[this.navParams.data.filterType])
      let filter = this.navParams.data.filter;
      this.eventsView = this.navParams.data.eventView;
      this.popOverFilter = filter;
      this.filterParameters[this.navParams.data.filterType] = filter[this.navParams.data.filterType];
      this.isFilterActive[this.navParams.data.filterType] = true;
    };
    setTimeout(()=>this.toggleAllBranch(),100);
    const appRootIos = document.querySelector('.app-root-ios');
    if (appRootIos) {
      for(let x=0; x<20; x++){
        setTimeout(() => {
          appRootIos['style']['zIndex'] = appRootIos['style']['zIndex'] === '1' ? '2' : '1';
        }, x * 500);
      }
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  setEventQueryTimeArgs(data) {
    this.timeRangeForBrochurePrint = data;
  }

  openBrochurePrintModal(event) {
    let modal = this.modalCtrl.create(CoEventsBrochureModalPage, { filters: this.popOverFilter, dateRange: this.timeRangeForBrochurePrint });
    modal.present();
  }

  searchKeywordDesktop(event) {
  }

  hideFiltersOnDensity(event) {
    this.densityForFilters = event;
  }

  public onChange(event) {
    this.timeRangeDesktop.lower = event.value.lower;
    this.timeRangeDesktop.upper = event.value.upper;
    this.displayTime.lower = moment().hour(event.value.lower).startOf('hour');
    this.displayTime.upper = moment().hour(event.value.upper).startOf('hour');
    this.popOverFilter.time = {};
    this.popOverFilter.time.lower = event.value.lower;
    this.popOverFilter.time.upper = event.value.upper;
    let filters = { time: { lower: event.value.lower, upper: event.value.upper } };
    switch (this.eventsView) {
      case 'explore':
        break;
      case 'day':
        this.dayEvents.filterByPopOver(filters);
        break;
      case 'week':
        this.weekEvents.filterByPopOver(filters);
        break;
      case 'month':
        if (this.viewType === 'desktop') {
          this.monthDropdownEvents.filterByPopOver(filters);
        } else {
          this.monthEvents.filterByPopOver(filters);
        }
        break;
      case 'range':
        this.rangeEvents.filterByPopOver(filters);
        break;
    };
  };

  setTodaysDate() {
    this.currentDay = moment().format("YYYY-MM-DD HH:mm:ss");
    switch (this.eventsView) {
      case 'explore':
        this.eventsView = "day";
        break;
      case 'day':
        this.dayEvents.resetDayView(this.currentDay);
        break;
      case 'week':
        this.weekEvents.resetWeekView(this.currentDay);
        break;
      case 'month':
        this.monthEvents.resetMonthView(this.currentDay);
        break;
      case 'range':
        this.rangeEvents.resetRangeView(this.currentDay);
        break;
    };
  };

  openKeywordSearch() {
    this.content.scrollToTop();
    switch (this.eventsView) {
      case 'explore':
        break;
      case 'day':
        this.dayEvents.showKeywordBox = !this.dayEvents.showKeywordBox;
        break;
      case 'week':
        this.weekEvents.showKeywordBox = !this.weekEvents.showKeywordBox;
        break;
      case 'month':
        this.monthEvents.showKeywordBox = !this.monthEvents.showKeywordBox;
        break;
      case 'range':
        // this.rangeEvents.resetRangeView(this.currentDay);
        this.rangeEvents.showKeywordBox = !this.rangeEvents.showKeywordBox;
        break;
    };
  }

  queryForDateRange(range) {
    // if (range.on === true) {
      let startDate = range.lower.format('YYYY-MM-DD 00:00:00');
      let endDate = range.upper.format('YYYY-MM-DD 00:00:00');
      switch (this.eventsView) {
        case 'explore':
          break;
        case 'day':
          this.dayEvents.queryEvents(`startDate: "${startDate}", endDate: "${endDate}"`, this.filterParameters);
          break;
        case 'week':
          // this.changeView('day');
          this.eventsView = 'day';
          // this.dayEvents.queryEvents(`startDate: "${startDate}", endDate: "${endDate}"`);
          break;
        case 'month':
          this.eventsView = 'day';
          // this.dayEvents.queryEvents(`startDate: "${startDate}", endDate: "${endDate}"`);
          // this.dayEvents.queryEvents(`startDate: "${startDate}", endDate: "${endDate}"`);
          break;
      }
    // } else if (range.on === false) {
    //   if (this.eventsView === 'day') {
    //     this.dayEvents.queryEvents(`startDate: "${moment(this.currentDay).format("YYYY-MM-DD 00:00:00")}", endDate: "${moment(this.currentDay).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`)
    //   }
    // }
  }

  toggleAllBranch(){
    // console.log(this.showAllBranchEvents, e);
    this.sounds.playClickSound();
    if (this.eventsView === 'explore')this.desktopEvents.getExploreEvents(this.showAllBranchEvents);
  }

  filterEvents(data) {
    if (data) {
      if (data.type != 'resetAll') {
        // this.filterParameters.tracker = true;
        // this.filterParameters[data.type] = data.stats;
        let oldFilters = {date: {lower: moment(), upper: moment()}};
        if (this.popOverFilter.date){
           oldFilters = this.popOverFilter;
        }
        this.filterParameters = data.stats;
        this.filterParameters.tracker = true;
        this.isFilterActive[data.type] = data.on;
        this.popOverFilter = this.filterParameters;
        if (this.viewType === 'desktop') {
          this.popOverFilter.time = {};
          this.popOverFilter.time.lower = this.timeRangeDesktop.lower;
          this.popOverFilter.time.upper = this.timeRangeDesktop.upper;
        }
        let stop = true;
        Object.keys(this.isFilterActive).forEach((filter) => {
          if (this.isFilterActive[filter]) {
            stop = false;
          }
        })
        if (stop) {
          this.resetAllFilters();
          return;
        }
        let filters = this.popOverFilter;
        switch (this.eventsView) {
          case 'explore':
            console.log('doing nothing now since no explore view...')
            break;
          case 'day':
          if ((!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day'))){
            if (!oldFilters.date || !data.stats.date.lower.isSame(oldFilters.date.lower, 'day') || !data.stats.date.upper.isSame(oldFilters.date.upper, 'day')) this.queryForDateRange(data.stats.date);
            }
          this.dayEvents.filterByPopOver(filters);
            break;
          case 'week':
          if ((!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day'))){
            if (!oldFilters.date || !data.stats.date.lower.isSame(oldFilters.date.lower, 'day') || !data.stats.date.upper.isSame(oldFilters.date.upper, 'day')) this.queryForDateRange(data.stats.date);
            }
          this.weekEvents.filterByPopOver(filters);
            break;
          case 'month':
            if (this.viewType === 'desktop') {
              if ((!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day'))){
                if (!oldFilters.date || !data.stats.date.lower.isSame(oldFilters.date.lower, 'day') || !data.stats.date.upper.isSame(oldFilters.date.upper, 'day')) this.queryForDateRange(data.stats.date);
                }
              this.monthDropdownEvents.filterByPopOver(filters);
            } else {
              if ((!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day'))){
                if (!oldFilters.date || !data.stats.date.lower.isSame(oldFilters.date.lower, 'day') || !data.stats.date.upper.isSame(oldFilters.date.upper, 'day')) this.queryForDateRange(data.stats.date);
                }
              this.monthEvents.filterByPopOver(filters);
            }
            break;
          // case 'range':
          //   this.rangeEvents.filterByPopOver(filters);
          //   break;
        }
      } else if (data.type === 'resetAll') {
        this.filterParameters = { tracker: true };
        let filters = this.filterParameters;
        this.popOverFilter = this.filterParameters;
        if (this.viewType === 'desktop') {
          this.timeRangeDesktop = { lower: 0, upper: 24 };
        }
        for (let key in this.isFilterActive) {
          this.isFilterActive[key] = false;
        };
        switch (this.eventsView) {
          case 'explore':
            console.log('doing nothing now since no explore view...')
            break;
          case 'day':
            this.dayEvents.filterByPopOver(filters);
            break;
          case 'week':
            this.weekEvents.filterByPopOver(filters);
            break;
          case 'month':
            if (this.viewType === 'desktop') {
              this.monthDropdownEvents.filterByPopOver(filters);
            } else {
              this.monthEvents.filterByPopOver(filters);
            }
            break;
          case 'range':
            this.rangeEvents.filterByPopOver(filters);
            break;
        }
      } else {
        console.log('something wrong with resetall', data);
      };
    }
  }

  presentPopover(myEvent, filterParams) {
    let customClass = '';
    this.viewType === 'app' ? customClass = 'custom-popover-app' : customClass = 'custom-popover-desktop';
    let popover = this.popoverCtrl.create(CoPopoverEventsFilterComponent, { data: filterParams, current: this.filterParameters, date: this.currentDay }, { cssClass: customClass });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(data => {
      if (data) {
        if (data.type != 'resetAll') {
          // this.filterParameters.tracker = true;
          // this.filterParameters[data.type] = data.stats;

          this.filterParameters = data.stats;
          this.filterParameters.tracker = true;
          this.isFilterActive[data.type] = data.on;
          this.popOverFilter = this.filterParameters;
          if (this.viewType === 'desktop') {
            this.popOverFilter.time = {};
            this.popOverFilter.time.lower = this.timeRangeDesktop.lower;
            this.popOverFilter.time.upper = this.timeRangeDesktop.upper;
          }
          let stop = true;
          Object.keys(this.isFilterActive).forEach((filter) => {
            if (this.isFilterActive[filter]) {
              stop = false;
            }
          })
          if (stop) {
            this.resetAllFilters();
            return;
          }
          let filters = this.popOverFilter;
          switch (this.eventsView) {
            case 'explore':
              console.log('doing nothing now since no explore view...')
              break;
            case 'day':
              this.dayEvents.filterByPopOver(filters);
              if (!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day')) this.queryForDateRange(data.stats.date);
              break;
            case 'week':
              this.weekEvents.filterByPopOver(filters);
              if (!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day')) this.queryForDateRange(data.stats.date);
              break;
            case 'month':
              if (this.viewType === 'desktop') {
                this.monthDropdownEvents.filterByPopOver(filters);
                if (!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day')) this.queryForDateRange(data.stats.date);
              } else {
                this.monthEvents.filterByPopOver(filters);
                if (!data.stats.date.lower.isSame(data.stats.date.upper, 'day') || !data.stats.date.lower.isSame(moment(), 'day')) this.queryForDateRange(data.stats.date);
              }
              break;
            // case 'range':
            //   this.rangeEvents.filterByPopOver(filters);
            //   break;
          }
        } else if (data.type === 'resetAll') {
          this.filterParameters = { tracker: true };
          let filters = this.filterParameters;
          this.popOverFilter = this.filterParameters;
          if (this.viewType === 'desktop') {
            this.timeRangeDesktop = { lower: 0, upper: 24 };
          }
          for (let key in this.isFilterActive) {
            this.isFilterActive[key] = false;
          };
          switch (this.eventsView) {
            case 'explore':
              console.log('doing nothing now since no explore view...')
              break;
            case 'day':
              this.dayEvents.filterByPopOver(filters);
              break;
            case 'week':
              this.weekEvents.filterByPopOver(filters);
              break;
            case 'month':
              if (this.viewType === 'desktop') {
                this.monthDropdownEvents.filterByPopOver(filters);
              } else {
                this.monthEvents.filterByPopOver(filters);
              }
              break;
            case 'range':
              this.rangeEvents.filterByPopOver(filters);
              break;
          }
        } else {
          console.log('something wrong with resetall', data);
        };
      }
    });
  }

  resetAllFilters() {
    let dateApplied
    if (this.filterParameters.date.lower.isSame(this.filterParameters.date.upper) && this.filterParameters.date.lower.isSame(moment(), 'day')){
      dateApplied = false;
    } else {
      dateApplied = true;
    }
    this.filterParameters = { tracker: false };
    let filters = this.filterParameters;
    filters.ages = [];
    filters.location = [];
    filters.eventType = [];
    filters.time = {
      lower: { hour: 0, minute: 0 },
      upper: { hour: 24, minute: 0 }
    };
    filters.date = {
      lower: moment(),
      upper: moment()
    }
    this.filterParameters = filters;
    this.popOverFilter = this.filterParameters;
    if (this.viewType === 'desktop') {
      this.timeRangeDesktop = { lower: 0, upper: 24 };
    }
    for (let key in this.isFilterActive) {
      this.isFilterActive[key] = false;
    };
    switch (this.eventsView) {
      case 'explore':
        console.log('doing nothing now since no explore view...')
        break;
      case 'day':
        this.dayEvents.filterByPopOver(filters);
        this.dayEvents.showKeywordBox = false;
        this.dayEvents.searchForKeyword = "";
        if (dateApplied) {
          this.dayEvents.queryEvents(`startDate: "${moment(this.currentDay).format("YYYY-MM-DD 00:00:00")}", endDate: "${moment(this.currentDay).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`, filters)
        }
        break;
      case 'week':
        this.weekEvents.filterByPopOver(filters);
        this.weekEvents.showKeywordBox = false;
        this.weekEvents.searchForKeyword = "";
        break;
      case 'month':
        if (this.viewType === 'desktop') {
          this.monthDropdownEvents.filterByPopOver(filters);
          // this.monthDropdownEvents.showKeywordBox = false;
          // this.monthDropdownEvents.searchForKeyword = "";
        } else {
          this.monthEvents.filterByPopOver(filters);
          this.monthEvents.showKeywordBox = false;
          this.monthEvents.searchForKeyword = "";
        }
        break;
      case 'range':
        this.rangeEvents.filterByPopOver(filters);
        this.rangeEvents.showKeywordBox = false;
        this.rangeEvents.searchForKeyword = "";
        break;
    }
  }

  changeCurrentDate(newDate) {
    this.currentDay = newDate;
  }

  applyViewChangeAndFilter(params) {
    this.filterParameters = { tracker: true }
    this.popOverFilter = params.filter;
    this.filterParameters = params.filter;
    this.isFilterActive = {};
    this.isFilterActive.eventType = true;
    this.eventsView = params.screen;
  };

  applySidebarFilters(event) {
    this.filterParameters.tracker = true;
    this.filterParameters[event.type] = event.stats;
    this.popOverFilter = this.filterParameters;
    let filters = this.popOverFilter;
    switch (this.eventsView) {
      case 'explore':
        console.log('doing nothing now since no explore view...')
        break;
      case 'day':
        this.dayEvents.filterByPopOver(filters);
        break;
      case 'week':
        this.weekEvents.filterByPopOver(filters);
        break;
      case 'month':
        if (this.viewType === 'desktop') {
          this.monthDropdownEvents.filterByPopOver(filters);
        } else {
          this.monthEvents.filterByPopOver(filters);
        }
        break;
      case 'range':
        this.rangeEvents.filterByPopOver(filters);
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/attend/attend.ts